import React, { useState, useEffect, useRef, useContext } from "react";
import { C4FStatusContext, UserInformationContext, InfoModalContext, ReferenceDataContext } from "../main/App";
import { DropdownButton, ButtonGroup, Dropdown, Button, Form, Row, Alert, Modal, Container, Table, InputGroup, Col } from 'react-bootstrap';
import C4FSimpleTable from "../common/C4FSimpleTable";
import { getJersey } from "../race/C4FLeaderJerseys";
import '../css/general.css';
import { currentISODate, getCountryName, getUnicodeFlag, getUnicodeOrImageFlag, getRegularTeam, formatCurrency } from "../common/Helpers";
import C4FInfoButton from "../common/C4FInfoButton";
import Chart from "react-apexcharts";


function RiderInfo(props) {

    const mounted = useRef(false);
    const { handleBackendRequest, browserInfo, raiseError } = useContext(C4FStatusContext);
    const { userInformation } = useContext(UserInformationContext);
    const { showTeamInfo } = useContext(InfoModalContext);
    const { countries } = useContext(ReferenceDataContext);
    const [rider, setRider] = useState(null);

    const [tab, setTab] = useState('overview');

    const [baptiseFirstName, setBaptiseFirstName] = useState('');
    const [baptiseLastName, setBaptiseLastName] = useState('');
    const [baptiseAdditionalInformation, setBaptiseAdditionalInformation] = useState('');
    const [baptiseNationality, setBaptiseNationality] = useState('');
    const [isGeneratedName, setGeneratedName] = useState(false);
    const [showBaptiseModal, setShowBaptiseModal] = useState(false);
    const [resetNationality, setResetNationality] = useState('');

    const [additionalInformation, setAdditionalInformation] = useState('');
    const [nickname, setNickname] = useState('');

    function handleResetName() {
        setGeneratedName(false);
        setBaptiseFirstName('');
        setBaptiseLastName('');
        setBaptiseAdditionalInformation('');
    }

    function handleGenerateName() {
        handleBackendRequest('POST', '/rider/' + props.riderId + '/generateName',
            {},
            {
                nationality: baptiseNationality
            },
            function (generatedName) {
                if (generatedName.firstName !== '' && generatedName.lastName !== '') {
                    setBaptiseFirstName(generatedName.firstName);
                    setBaptiseLastName(generatedName.lastName);
                    setBaptiseAdditionalInformation('generated name for ' + baptiseNationality)
                    setGeneratedName(true);
                }
            });

    }

    function handleBaptiseCheck() {
        if (baptiseFirstName.length < 2 || baptiseLastName.length < 2)
            raiseError('Functional Error', 0, 'Rider name too short, minimum length for first name and last name is 2.');
        else if (baptiseFirstName.length + baptiseLastName.length >= 30)
            raiseError('Functional Error', 0, 'Rider name too long, max 30 characters allowed (first name + last name + whitespace).');
        else if (baptiseAdditionalInformation.length > 100)
            raiseError('Functional Error', 0, 'Additional information too long, max 100 characters allowed.');
        else setShowBaptiseModal(true);
    }

    const handleBaptise = () => baptise();
    function baptise() {
        setShowBaptiseModal(false);
        handleBackendRequest('POST', '/rider/' + props.riderId + '/baptise',
            {},
            {
                firstNames: baptiseFirstName,
                lastNames: baptiseLastName,
                additionalInformation: baptiseAdditionalInformation,
                nationality: baptiseNationality
            },
            handleUpdateRiderInfoOnly);
    }

    function handleResetNationality() {
        handleBackendRequest('POST', '/rider/' + props.riderId + '/resetNationality', null, { nationality: resetNationality }, handleUpdateRiderInfoOnly);
    }

    function patchRider(key, value) {
        handleBackendRequest('PATCH', '/rider/' + props.riderId, {},
            {
                key: key,
                value: value
            },
            handleUpdateRiderInfoOnly);
    }

    function loadRider() {
        handleBackendRequest('GET', '/rider/' + props.riderId, null,
            {
                returnTransfers: true,
                returnTrainingHistory: true,
                returnPrivateInfo: userInformation && getRegularTeam(userInformation).id === props.teamId
            },
            handleSetRider);
    }

    function handleSetRider(rider) {
        setAdditionalInformation(rider.additionalInformation ? rider.additionalInformation : '');
        setNickname(rider.nickname ? rider.nickname : '');
        rider.skillDevelopment = getSkillDevelopment(rider);
        rider.skillStatistics = getSkillStatistics(rider);
        setRider(rider);
    }

    function handleUpdateRiderInfoOnly(updatedRider) {
        updatedRider.skillDevelopment = rider.skillDevelopment;
        updatedRider.skillStatistics = rider.skillStatistics;
        setAdditionalInformation(updatedRider.additionalInformation ? updatedRider.additionalInformation : '');
        setNickname(updatedRider.nickname ? updatedRider.nickname : '');
        setRider(updatedRider);
    }

    function getSkillDevelopment(rider) {
        // prepopulate training sessions (per age)
        let today = new Date();
        let latestPossibleTrainingDate = rider.status === 'Retired' ?
            new Date(Date.parse(rider.transfers[0].date)) : today;
        latestPossibleTrainingDate.setHours(12);
        latestPossibleTrainingDate.setMinutes(0);
        latestPossibleTrainingDate.setSeconds(0);

        let skillDevelopment = [];
        let allTrainingDays = [];
        for (let i = 21; i <= rider.age; i++) {
            let sessionOne = new Date(latestPossibleTrainingDate.getFullYear(), latestPossibleTrainingDate.getMonth() - rider.age + i, 5, 12);
            if (sessionOne <= latestPossibleTrainingDate)
                allTrainingDays.push({ age: i, session: 1, date: sessionOne.toISOString().substring(0, 10) });
            let sessionTwo = new Date(latestPossibleTrainingDate.getFullYear(), latestPossibleTrainingDate.getMonth() - rider.age + i, 12, 12);
            if (sessionTwo <= latestPossibleTrainingDate)
                allTrainingDays.push({ age: i, session: 2, date: sessionTwo.toISOString().substring(0, 10) });
            let sessionThree = new Date(latestPossibleTrainingDate.getFullYear(), latestPossibleTrainingDate.getMonth() - rider.age + i, 20, 12);
            if (sessionThree <= latestPossibleTrainingDate)
                allTrainingDays.push({ age: i, session: 3, date: sessionThree.toISOString().substring(0, 10) });
            let sessionFour = new Date(latestPossibleTrainingDate.getFullYear(), latestPossibleTrainingDate.getMonth() - rider.age + i, 27, 12);
            if (sessionFour <= latestPossibleTrainingDate)
                allTrainingDays.push({ age: i, session: 4, date: sessionFour.toISOString().substring(0, 10) });
        }

        let currentSkills = {
            Climbing: rider.skills.Climbing,
            Flat: rider.skills.Flat,
            Downhill: rider.skills.Downhill,
            TimeTrial: rider.skills.TimeTrial,
            Sprint: rider.skills.Sprint
        }

        allTrainingDays.reverse().forEach(td => {
            if (td.date <= currentISODate) {
                skillDevelopment.push({
                    ...td,
                    ...currentSkills
                });
                let currentTraining = rider.trainingHistory.filter(th => th.date === td.date);
                currentSkills = {
                    Climbing: currentSkills.Climbing - (currentTraining.some(t => t.skill === 'Climbing') ?
                        currentTraining.find(t => t.skill === 'Climbing').result : 0),
                    Flat: currentSkills.Flat - (currentTraining.some(t => t.skill === 'Flat') ?
                        currentTraining.find(t => t.skill === 'Flat').result : 0),
                    Downhill: currentSkills.Downhill - (currentTraining.some(t => t.skill === 'Downhill') ?
                        currentTraining.find(t => t.skill === 'Downhill').result : 0),
                    TimeTrial: currentSkills.TimeTrial - (currentTraining.some(t => t.skill === 'TimeTrial') ?
                        currentTraining.find(t => t.skill === 'TimeTrial').result : 0),
                    Sprint: currentSkills.Sprint - (currentTraining.some(t => t.skill === 'Sprint') ?
                        currentTraining.find(t => t.skill === 'Sprint').result : 0)
                }
            }
        });
        skillDevelopment.push({
            age: allTrainingDays.length === 0 ? rider.age : allTrainingDays[allTrainingDays.length - 1].age,
            session: 0,
            date: '-',
            ...currentSkills
        });
        return skillDevelopment.reverse();
    }

    function getSkillStatistics(rider) {
        // count trainings
        let skillStatistics = [];
        ['Climbing', 'Flat', 'Downhill', 'TimeTrial', 'Sprint'].forEach(skill =>
            skillStatistics.push({
                skill: skill,
                start: rider.skillDevelopment[0][skill],
                up: rider.trainingHistory.filter(t => t.skill === skill && t.result > 0).length,
                down: rider.trainingHistory.filter(t => t.skill === skill && t.result < 0).length
            }));

        // find min / max skills
        ['Climbing', 'Flat', 'Downhill', 'TimeTrial', 'Sprint'].forEach(skill => {
            let skillStatistic = skillStatistics.find(s => s.skill === skill);
            skillStatistic.max = Math.max(...(rider.skillDevelopment.map(rd => rd[skill])));
            skillStatistic.min = Math.min(...(rider.skillDevelopment.map(rd => rd[skill])));
        })
        return skillStatistics;
    }

    function handleRiderPalmares() {
        if (!rider.palmares) {
            handleBackendRequest('GET', '/rider/' + props.riderId, null, { returnPalmares: true },
                function (returnedRider) {
                    setRider({ ...rider, ...returnedRider });
                    setTab('palmares');
                });
        }
        else
            setTab('palmares');
    }

    function handleRiderRaceHistory() {
        if (!rider.raceHistory) {
            handleBackendRequest('GET', '/rider/' + props.riderId, null, { returnRaceHistory: true },
                function (returnedRider) {
                    setRider({ ...rider, ...returnedRider });
                    setTab('raceHistory');
                });
        }
        else
            setTab('raceHistory');
    }


    function getNCResultSignalAndReason(ncResult) {
        switch (ncResult) {
            case 'Clone': return getNCResultSignal(ncResult) + ' (clone)';
            case 'WrongNation': return getNCResultSignal(ncResult) + ' (wrong nation)';
            case 'UnrealisticName': return getNCResultSignal(ncResult) + ' (unrealistic)';
            default: return getNCResultSignal(ncResult);
        }
    }

    function getNCResultSignal(ncResult) {
        switch (ncResult) {
            case 'None': return '\u26AA';
            case 'Open': return '\uD83D\uDFE1';
            case 'Accepted': return '\uD83D\uDFE2';
            default: return '\uD83D\uDD34';
        }
    }

    useEffect(() => {
        mounted.current = true;
    }, []);

    useEffect(() => {
        return () => mounted.current = false;
    }, []);

    useEffect(() => {
        if (mounted.current) {
            if (props.riderId !== null)
                loadRider();
        }
        else {
        }
    }, []);

    if (rider !== null)
        return <Container fluid className="m-0 p-0 justify-content-center">
            <Row className="d-flex mt-1 p-1 justify-content-center" >
                <Col className=" m-1 p-1" style={{ maxHeight: 600, backgroundColor: 'rgba(222,233,244,1)' }}>
                    <Row className="d-flex mt-1 p-1 justify-content-center">
                        <h5>
                            {getUnicodeOrImageFlag(countries, rider.nationality, browserInfo)}
                            {rider.firstNames + ' ' +
                                (rider.nickname && rider.nickname.length > 0 ? '"' + rider.nickname + '" ' : '') +
                                rider.lastNames +
                                ' (' + rider.ownerName + ')'}
                        </h5>
                    </Row>
                    <Row className="d-flex mt-1 p-1 justify-content-center">
                        <ButtonGroup>
                            <Button variant={(tab === 'overview') ? 'secondary py-0' : 'outline-secondary py-0'}
                                onClick={() => setTab('overview')}>Stats</Button>
                            <Button variant={(tab === 'palmares') ? 'secondary py-0' : 'outline-secondary py-0'}
                                onClick={() => handleRiderPalmares()}>Palmarès</Button>
                            <Button variant={(tab === 'transfers') ? 'secondary py-0' : 'outline-secondary py-0'}
                                onClick={() => setTab('transfers')}>Transfers</Button>
                            <Button variant={(tab === 'training') ? 'secondary py-0' : 'outline-secondary py-0'}
                                onClick={() => setTab('training')}>Training</Button>
                            <Button variant={(tab === 'development') ? 'secondary py-0' : 'outline-secondary py-0'}
                                onClick={() => setTab('development')}>Development</Button>
                            <Button variant={(tab === 'raceHistory') ? 'secondary py-0' : 'outline-secondary py-0'}
                                onClick={() => handleRiderRaceHistory()}>Race History</Button>
                        </ButtonGroup>
                    </Row>
                </Col>
            </Row>
            {tab === 'overview' ?
                <Row className="d-flex mt-1 p-1 justify-content-center" style={{ maxHeight: 600, overflow: "auto", backgroundColor: 'rgba(245,250,255,1)' }}>
                    <Col className="m-1 p-1" style={{ minWidth: 300, maxHeight: 600, overflow: "auto", backgroundColor: 'rgba(245,250,255,1)' }}>
                        <Table striped size="sm">
                            <tbody>
                                <tr>
                                    <td><b><u>GENERAL STATS</u></b></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td><b>ID</b></td>
                                    <td>{props.riderId}</td>
                                </tr>
                                <tr>
                                    <td><b>Nationality</b></td>
                                    <td>
                                        {rider.nationality === 'UN' && rider.nationsCommitteeResult === 'WrongNation' &&
                                            userInformation && getRegularTeam(userInformation).id === rider.owner ?
                                            <ButtonGroup>
                                                <DropdownButton variant={'outline-secondary'} size="sm"
                                                    title={(resetNationality === '') ? 'select country' : getUnicodeFlag(resetNationality) + ' ' + getCountryName(countries, resetNationality)}
                                                    onSelect={(nationality, e) => setResetNationality(nationality)} >
                                                    {countries
                                                        .filter(c => c.isRiderNationality)
                                                        .sort(function (a, b) { b.country.localeCompare(a.country) })
                                                        .map(country => (
                                                            <Dropdown.Item eventKey={country.countryCode} className="narrow-dropdown">
                                                                {getUnicodeOrImageFlag(countries, country.countryCode, browserInfo)} {country.country}
                                                            </Dropdown.Item>
                                                        ))}
                                                </DropdownButton>
                                                <Button disabled={!resetNationality || resetNationality === ''} size="sm" 
                                                    onClick={() => handleResetNationality()}>Submit</Button>
                                            </ButtonGroup>
                                            :
                                            <a>{getCountryName(countries, rider.nationality)}</a>
                                        }

                                    </td>
                                </tr>
                                {(() => {
                                    if (rider.named || !(userInformation && getRegularTeam(userInformation).id === rider.owner))
                                        return <>
                                            <tr>
                                                <td><b>Name</b></td>
                                                <td>{rider.firstNames}&nbsp;{rider.lastNames} {getNCResultSignalAndReason(rider.nationsCommitteeResult)}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Nickname</b></td>
                                                <td>
                                                    {userInformation && getRegularTeam(userInformation).id === rider.owner ?
                                                        <InputGroup >
                                                            <C4FInfoButton size="sm" title="Nickname" text="Nickname of the rider, only available for successful and well known riders (at least 100 races or 3000 points)" />
                                                            <Form.Control size="sm" type={'text'}
                                                                onChange={(e) => setNickname(e.target.value)}
                                                                placeholder={''}
                                                                value={nickname} />
                                                            {nickname.length > 30 ?
                                                                <Button size="sm" variant={'warning'} disabled >{'\u26A0'}</Button>
                                                                : null}
                                                            <Button size="sm" variant={'primary'} disabled={!(rider.pointsEternal >= 3000 ||
                                                                rider.raceStatistics !== null && rider.raceStatistics.TotalRaces >= 100)}
                                                                onClick={() => patchRider('nickname', nickname)}>update</Button>
                                                        </InputGroup>
                                                        :
                                                        rider.nickname
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><b>Additional Information</b></td>
                                                <td>
                                                    {userInformation && getRegularTeam(userInformation).id === rider.owner ?
                                                        <InputGroup >
                                                            <C4FInfoButton size="sm" title="Additional Information" text="Additional information about the rider, used by nations committee to approve the name, and as information for other players" />
                                                            <Form.Control size="sm" type={'text'}
                                                                onChange={(e) => setAdditionalInformation(e.target.value)}
                                                                placeholder={'additional information'}
                                                                value={additionalInformation} />
                                                            {additionalInformation.length > 100 ?
                                                                <Button size="sm" variant={'warning'} disabled >{'\u26A0'}</Button>
                                                                : null}
                                                            <Button size="sm" variant={'primary'}
                                                                onClick={() => patchRider('additionalInformation', additionalInformation)}>update</Button>
                                                        </InputGroup>
                                                        :
                                                        rider.additionalInformation
                                                    }
                                                </td>
                                            </tr>
                                        </>
                                    else
                                        return <tr>
                                            <td><b>Name</b></td>
                                            <td>
                                                <Modal key={'baptiseModal' + showBaptiseModal}
                                                    show={showBaptiseModal}
                                                    onHide={() => setShowBaptiseModal(false)} >
                                                    <Modal.Header closeButton>
                                                        <Modal.Title>Confirmation of National Committee (NC) Rules</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <p>I confirm that the first name and last name exist in reality, or at least sound realistic, for the selected nation.</p>
                                                        <ul>
                                                            <li>No 'clone' of existing riders through adding, deleting or changing letters (e.g. "Wout VanArt" or "Matthieu VanDerPoel")</li>
                                                            <li>No nicknames (e.g. "King Küng")</li>
                                                            <li>No fantasy names(e.g. "Darth Vader")</li>
                                                            <li>No artist names (e.g. "Avicii")</li>
                                                        </ul>
                                                        <p>More details under Manual, Nations</p>
                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                        <Button variant="secondary" onClick={() => setShowBaptiseModal(false)}>{'Cancel'}</Button>
                                                        <Button variant="primary" onClick={handleBaptise}>{'OK'}</Button>
                                                    </Modal.Footer>
                                                </Modal>
                                                <Form.Control
                                                    onChange={(e) => setBaptiseFirstName(e.target.value)}
                                                    disabled={isGeneratedName}
                                                    placeholder="first name"
                                                    value={baptiseFirstName} />
                                                <Form.Control className={'mt-1'}
                                                    onChange={(e) => setBaptiseLastName(e.target.value)}
                                                    disabled={isGeneratedName}
                                                    placeholder="last name"
                                                    value={baptiseLastName} />
                                                <Form.Control className={'mt-1'}
                                                    onChange={(e) => setBaptiseAdditionalInformation(e.target.value)}
                                                    disabled={isGeneratedName}
                                                    placeholder="additional information (for NC)"
                                                    value={baptiseAdditionalInformation} />
                                                <DropdownButton className={'my-1'} variant={'outline-secondary'} size="sm"
                                                    title={(baptiseNationality === '') ? 'select country' : getUnicodeFlag(baptiseNationality) + ' ' + getCountryName(countries, baptiseNationality)}
                                                    disabled={isGeneratedName}
                                                    onSelect={(nationality, e) => setBaptiseNationality(nationality)} >
                                                    {countries
                                                        .filter(c => c.isRiderNationality)
                                                        .sort(function (a, b) { b.country.localeCompare(a.country) })
                                                        .map(country => (
                                                            <Dropdown.Item eventKey={country.countryCode} className="narrow-dropdown">
                                                                {getUnicodeOrImageFlag(countries, country.countryCode, browserInfo)} {country.country}
                                                            </Dropdown.Item>
                                                        ))}
                                                </DropdownButton>
                                                <Button size="sm" variant={'primary'} onClick={() => handleGenerateName()} disabled={baptiseNationality === ''} >Generate</Button>
                                                <Button className={'mx-1'} size="sm" variant={'danger'} onClick={() => handleResetName()}>Reset</Button>
                                                <Button size="sm" variant={'success'} onClick={() => handleBaptiseCheck()}>Submit</Button>
                                                {baptiseFirstName.length + baptiseLastName.length >= 30 ?
                                                    <Alert key="alert1" variant={'warning'}>Maximum length: 30 characters (incl. whitespace)</Alert>
                                                    : null}
                                            </td>
                                        </tr>
                                })()}
                                <tr>
                                    <td><b>Team</b></td>
                                    <td>
                                        <a href="#" onClick={() => showTeamInfo(rider)} style={{ color: '#000000' }}>
                                            {rider.ownerName}
                                        </a>
                                    </td>
                                </tr>
                                <tr>
                                    <td><b>Age</b></td>
                                    <td>{rider.age} years</td>
                                </tr>
                                <tr>
                                    <td><b>Status</b></td>
                                    <td>
                                        {rider.status}
                                        {rider.reducedPurchase ? ' (reduced purchase)' : ''}
                                    </td>
                                </tr>
                                {rider.status !== 'Retired' ? 
                                    <>
                                        <tr>
                                            <td><b>Market Value</b></td>
                                            <td>{formatCurrency(rider.marketValue)}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Salary</b></td>
                                            <td>{formatCurrency(rider.salary)}</td>
                                        </tr>
                                    </>
                                : null }
                                <tr>
                                    <td><b>Total Races</b></td>
                                    <td>{rider.raceStatistics !== null ? rider.raceStatistics.TotalRaces : 0}</td>
                                </tr>
                                {rider.status !== 'Retired' ? 
                                    <>
                                        <tr>
                                            <td><b>Points - Previous Season</b></td>
                                            <td>{(rider.status === 'Active') ? rider.pointsPreviousSeason : 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Points - Current Season</b></td>
                                            <td>{(rider.status === 'Active') ? rider.pointsCurrentSeason : 'N/A'}</td>
                                        </tr>
                                    </>
                                : null }
                                <tr>
                                    <td><b>Points - Eternal</b></td>
                                    <td>{(rider.status === 'Active' || rider.status === 'Retired') ? rider.pointsEternal.toLocaleString("en-EN") : 'N/A'}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                    <Col className="m-1 p-1" style={{ minWidth: 300, maxHeight: 600, overflow: "auto", backgroundColor: 'rgba(245,250,255,1)' }}>
                        <Table striped size="sm">
                            <tbody>
                                <tr>
                                    <td><b><u>PALMARÈS</u></b></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td><b>{'\uD83C\uDFC6'}Race Wins</b></td>
                                    <td>{(rider.raceStatistics !== null) ? rider.raceStatistics.RaceWins : 0}</td>
                                </tr>
                                <tr>
                                    <td><b><img alt="GCLeader" title="Stage Race Wins" src={getJersey('Le Tour', 'GCLeader')} style={{ maxHeight: "18px", marginBottom: 1 }} />{'\uD83E\uDD47'}Stage Race Wins</b></td>
                                    <td>{(rider.raceStatistics !== null) ? rider.raceStatistics.StageRaceWins : 0}</td>
                                </tr>
                                <tr>
                                    <td><b>{'\uD83E\uDD48\uD83E\uDD49'}Stage Race Podiums</b></td>
                                    <td>{(rider.raceStatistics !== null) ? rider.raceStatistics.StageRacePodiums : 0}</td>
                                </tr>
                                <tr>
                                    <td><b><img alt="GCLeader" title="Points Jerseys" src={getJersey('Le Tour', 'Sprint')} style={{ maxHeight: "18px", marginBottom: 1 }} />Points Jerseys</b></td>
                                    <td>{(rider.raceStatistics !== null) ? rider.raceStatistics.SprintJerseys : 0}</td>
                                </tr>
                                <tr>
                                    <td><b><img alt="GCLeader" title="Mountain Jerseys" src={getJersey('Le Tour', 'Mountain')} style={{ maxHeight: "18px", marginBottom: 1 }} />Mountain Jerseys</b></td>
                                    <td>{(rider.raceStatistics !== null) ? rider.raceStatistics.MountainJerseys : 0}</td>
                                </tr>
                                <tr>
                                    <td><b><img alt="GCLeader" title="Youth Jerseys" src={getJersey('Le Tour', 'Youth')} style={{ maxHeight: "18px", marginBottom: 1 }} />Youth Jerseys</b></td>
                                    <td>{(rider.raceStatistics !== null) ? rider.raceStatistics.YouthJerseys : 0}</td>
                                </tr>
                                <tr>
                                    <td><b><u>SKILLS</u></b></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td><b>Climbing</b></td>
                                    <td>{rider.skills.Climbing}</td>
                                </tr>
                                <tr>
                                    <td><b>Flat</b></td>
                                    <td>{rider.skills.Flat}</td>
                                </tr>
                                <tr>
                                    <td><b>Downhill</b></td>
                                    <td>{rider.skills.Downhill}</td>
                                </tr>
                                <tr>
                                    <td><b>TimeTrial</b></td>
                                    <td>{rider.skills.TimeTrial}</td>
                                </tr>
                                <tr>
                                    <td><b>Sprint</b></td>
                                    <td>{rider.skills.Sprint}</td>
                                </tr>
                                <tr>
                                    <td><b>Cobbles</b></td>
                                    <td>{(rider.skills.Cobbles * 0.3 + rider.skills.Flat * 0.7).toLocaleString(navigator.language, { maximumFractionDigits: 1 })}</td>
                                </tr>
                                <tr>
                                    <td><b>Regeneration</b></td>
                                    <td>{rider.skills.Regeneration}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                : null}
            {tab === 'palmares' && rider.palmares ?
                <Row className=" d-flex mt-1 p-1 justify-content-center">
                    <Col className="col-10 m-1 p-1" style={{ minWidth: 400, maxHeight: 600 }}>
                        <h5><u>Palmarès</u></h5>
                        <C4FSimpleTable key={'riderPalmares'}
                            initialSortingColumn={'date'}
                            initialSortingAscending={false}
                            hideFilterButtons={false}
                            data={rider.palmares}
                            rowMetadata={[
                                { columnName: 'date', columnDescription: 'Date' },
                                { columnName: 'type', columnDescription: 'Type' },
                                { columnName: 'raceName', columnDescription: 'Race' },
                                { columnName: 'category', columnDescription: 'Cat.' },
                                { columnName: 'group', columnDescription: 'Group' }
                            ]}
                        />
                    </Col>
                </Row>
                : null}
            {tab === 'transfers' && rider.transfers ?
                <Row className="d-flex mt-1 p-1 justify-content-center">
                    <Col className="col-8 m-1 p-1" style={{ minWidth: 400, maxHeight: 600 }}>
                        <h5><u>Transfers</u></h5>
                        <C4FSimpleTable key={'riderTransfers'}
                            initialSortingColumn={'date'}
                            initialSortingAscending={false}
                            hideFilterButtons={true}
                            data={rider.transfers}
                            rowMetadata={[
                                { columnName: 'date', columnDescription: 'Date' },
                                { columnName: 'type', columnDescription: 'Type' },
                                { columnName: 'teamName', columnDescription: 'Team', cellClickEvent: showTeamInfo },
                                { columnName: 'price', columnDescription: 'Price', columnType: 'currency' }
                            ]}
                        />
                    </Col>
                </Row>
                : null}
            {tab === 'development' && rider.trainingHistory ?
                <Row className="d-flex mt-1 p-1 justify-content-center">
                    <Col className="col-10 m-1 p-1" style={{ maxHeight: 580 }}>
                        <Chart type="line" options={{
                            xaxis: {
                                categories: rider.skillDevelopment.map(sd => sd.age + '-' + sd.session)
                            },
                            dataLabels: {
                                enabled: false
                            },
                            stroke: {
                                curve: 'straight',
                                width: 2
                            },
                            markers: {
                            size: 5
                            }
                        }}
                            series={['Climbing', 'Flat', 'Downhill', 'TimeTrial', 'Sprint'].map(skill => ({
                                name: skill,
                                data: rider.skillDevelopment.map(sd => sd[skill])
                            }))}
                        />
                    </Col>
                </Row>
                : null}
            {tab === 'training' && rider.trainingHistory ?
                <Row className="d-flex mt-1 p-1 justify-content-center">
                    <Col className="col-6 m-1 p-1" style={{ maxHeight: 500 }}>
                        <C4FSimpleTable key={'trainingStats'}
                            hideFilterButtons={true}
                            data={rider.skillStatistics}
                            rowMetadata={[
                                { columnName: 'skill', columnDescription: 'Skill' },
                                { columnName: 'start', columnDescription: 'Start' },
                                { columnName: 'min', columnDescription: 'Min' },
                                { columnName: 'max', columnDescription: 'Max' },
                                { columnName: 'up', columnDescription: 'Up' },
                                { columnName: 'down', columnDescription: 'Down' }
                            ]}
                        />
                    </Col>
                </Row>
                : null}
            {tab === 'raceHistory' && rider.raceHistory ?
                <Row className="d-flex mt-1 p-1 justify-content-center">
                    <Col className="col-8 m-1 p-1" style={{ minWidth: 400, maxHeight: 600 }}>
                        <h5><u>Race History</u></h5>
                        <C4FSimpleTable key={'raceHistory'}
                            initialSortingColumn={'startingDate'}
                            initialSortingAscending={false}
                            hideFilterButtons={false}
                            data={rider.raceHistory}
                            rowMetadata={[
                                { columnName: 'raceName', columnDescription: 'Race' },
                                { columnName: 'stageNumber', columnDescription: 'Stage' },
                                { columnName: 'startingDate', columnDescription: 'Date' },
                                { columnName: 'position', columnDescription: 'Position' }
                            ]}
                        />
                    </Col>
                </Row>
                : null}
        </Container>
    else
        return null;
}

export default RiderInfo;